// import { DateTime } from 'luxon';
import { IS_LOCAL } from '@/helpers';
import i18n from '@/plugins/i18n';
import { status0, status1, status2, status3 } from './pick_the_fate_sample';

/**
 * @description 에러 모달 오픈
 */
function openErrModal(errModal, e) {
  console.error(e);

  errModal.open({
    // 오류가 발생했습니다.
    title: e.response?.data?.message?.title ?? i18n.t('etc.modalerr'),
    content: e.response?.data?.message?.content ?? e.response?.data?.message?.replaceAll('|', '<br />') ?? e,
    cancel: false,
  });
}

export default {
  namespaced: true,
  state() {
    return {
      // 시즌 정보 리스트
      seasonList: [],
      // 시즌별 일자별 정보 목록
      seasonDayList: [],
      // 시즌 리더보드 정보
      seasonLeaderBoard: {
        my: {},
        data: [],
      },
      // 시즌 리더보드 상세 모달 정보
      seasonLeaderBoardDetail: {},
      // 시즌 리더보드 보상 모달 정보
      seasonReward: {},
      // 시즌 일자별 상세
      seasonDayCaseList: {},
      // 시즌 일자별 케이스별 상세
      seasonDayCaseDetail: {},
    };
  },
  mutations: {
    // 시즌 리스트
    setSeasonList(state, seasonList) {
      state.seasonList = seasonList;
    },
    // 시즌 별 목록
    setSeasonDayList(state, seasonDayList) {
      state.seasonDayList = seasonDayList;
    },
    // 시즌 리더보드
    setSeasonLeaderBoard(state, seasonLeaderBoard) {
      state.seasonLeaderBoard = seasonLeaderBoard;
    },
    // 시즌 리더보드 상세
    setSeasonLeaderBoardDetail(state, seasonLeaderBoardDetail) {
      state.seasonLeaderBoardDetail = seasonLeaderBoardDetail;
    },
    // 시즌 리더보드 보상
    setSeasonReward(state, seasonReward) {
      state.seasonReward = seasonReward;
    },
    // 시즌 일자별 상세
    setSeasonDayCaseList(state, seasonDayCaseList) {
      state.seasonDayCaseList = seasonDayCaseList;
    },
    // 시즌 일자별 케이스별 상세
    setSeasonDayCaseDetail(state, seasonDayCaseDetail) {
      state.seasonDayCaseDetail = seasonDayCaseDetail;
    },
  },
  actions: {
    /**
     * @description API 호출
     */
    async fetch({ rootState: { vm, globalErrorModal } }, { method, url, params }) {
      const data = method === 'get' ? { params: { ...params } } : params;

      try {
        const { data: responseData } = await this._vm.$axios[method](
          `${process.env.VUE_APP_TEST_SERVER}${'/pick-the-fate' + url}`,
          data
        );
        return responseData;
      } catch (e) {
        if (e?.response?.status === 401) vm.$bvModal.show('login-required');
        else openErrModal(globalErrorModal, e);

        throw e;
      }
    },
    /** 시즌 정보 조회 */
    async getSeasonList({ dispatch }) {
      if (IS_LOCAL) {
        console.log('getSeasonList');
        return [
          {
            season: 3,
            startDate: '2025-03-24T00:00:00',
            endDate: '2025-03-31T23:59:59',
          },
          {
            season: 2,
            startDate: '2025-03-24T00:00:00',
            endDate: '2025-03-31T23:59:59',
          },
          {
            season: 1,
            startDate: '2025-03-12T00:00:00',
            endDate: '2025-03-24T23:59:59',
          },
        ]; // sort 최신 순
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/season',
      });

      return response;
    },
    /** 시즌 정보 조회 */
    async fetchSeasonList({ dispatch, commit }) {
      const data = await dispatch('getSeasonList');
      commit('setSeasonList', data);

      return;
    },
    /** 시즌별 day 목록 */
    async getSeasonDayList({ dispatch }, season) {
      if (IS_LOCAL) {
        console.log('getSeasonDayList', season);
        return [
          {
            day: 1,
            img: '',
            isParticipate: true, // false인 경우 미참여
            status: 2, // 0: 시작전, 1: 진행중, 2: 종료
            point: 50, // 종료전은 null,
            startDate: '2025-03-12', // 시작일
            endDate: '2025-03-19', // 종료일
            releaseDate: '2025-03-21', // 발표일
            cntParticipant: 3, //참여자수
          },
          {
            day: 2,
            img: '',
            isParticipate: false, // false인 경우 미참여
            status: 2, // 0: 시작전, 1: 진행중, 2: 종료
            point: 50, // 종료전은 null,
            startDate: '2025-03-12', // 시작일
            endDate: '2025-03-19', // 종료일
            releaseDate: '2025-03-21', // 발표일
            cntParticipant: 3, //참여자수
          },
          {
            day: 3,
            img: '',
            isParticipate: false, // false인 경우 미참여
            status: 2, // 0: 시작전, 1: 진행중, 2: 종료
            point: 50, // 종료전은 null,
            startDate: '2025-03-12', // 시작일
            endDate: '2025-03-19', // 종료일
            releaseDate: '2025-03-21', // 발표일
            cntParticipant: 3, //참여자수
          },
          {
            day: 4,
            img: '',
            isParticipate: true, // false인 경우 미참여
            status: 0, // 0: 시작전, 1: 진행중, 2: 종료
            point: 50, // 종료전은 null,
            startDate: '2025-03-12', // 시작일
            endDate: '2025-03-19', // 종료일
            releaseDate: '2025-03-21', // 발표일
            cntParticipant: 3, //참여자수
          },
          {
            day: 5,
            img: '',
            isParticipate: true, // false인 경우 미참여
            status: 1, // 0: 시작전, 1: 진행중, 2: 종료
            point: 50, // 종료전은 null,
            startDate: '2025-03-12', // 시작일
            endDate: '2025-03-19', // 종료일
            releaseDate: '2025-03-21', // 발표일
            cntParticipant: 3, //참여자수
          },
        ];
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: `/season/list`,
        params: {
          season,
        },
      });

      return response;
    },
    /** 시즌 별 목록 */
    async fetchSeasonDayList({ dispatch, commit }, season) {
      const seasonDayList = await dispatch('getSeasonDayList', season);
      commit('setSeasonDayList', seasonDayList);
      return;
    },
    /** 시즌 리더보드 조회 */
    async getSeasonLeaderBoard({ dispatch }, season) {
      if (IS_LOCAL) {
        console.log('getSeasonLeaderBoard', season);
        return {
          my: {
            rank: 1,
            usrName: 'aa***',
            point: 625,
          },
          data: [
            { etc: 1, rank: 1, point: 100, usrName: 'user1' },
            { etc: 2, rank: 2, point: 90, usrName: 'user2' },
            { etc: 0, rank: 3, point: 80, usrName: 'user3' },
            { etc: 0, rank: 4, point: 70, usrName: 'user4' },
            { etc: 0, rank: 5, point: 60, usrName: 'user5' },
            { etc: 0, rank: 6, point: 50, usrName: 'user6' },
            { etc: 0, rank: 7, point: 40, usrName: 'user7' },
            { etc: 0, rank: 8, point: 30, usrName: 'user8' },
            { etc: 0, rank: 9, point: 20, usrName: 'user9' },
            { etc: 0, rank: 10, point: 10, usrName: 'user10' },
          ],
        };
      }
      const response = await dispatch('fetch', {
        method: 'get',
        url: `/season/leaderboard`,
        params: {
          season,
        },
      });

      return response;
    },
    /** 시즌 리더보드 조회 */
    async fetchSeasonLeaderBoard({ dispatch, commit }, season) {
      const board = await dispatch('getSeasonLeaderBoard', season);

      commit('setSeasonLeaderBoard', board);
      return;
    },
    /** 시즌 리더보드 상세 조회 */
    async getSeasonLeaderBoardDetail({ dispatch }, { season, rank, isMine }) {
      if (IS_LOCAL) {
        console.log('getSeasonLeaderBoardDetail', season, rank, isMine);
        return !isMine
          ? [
              {
                usrName: 'abcdefghijklmno',
                point: [100, 500, null, null, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, null, 125, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, 125, 0, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, 100, 100, 100],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 500, 0, 0, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, 125, 125, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, 125, 0, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, 100, 100, 100],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 500, 0, 0, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, 125, 125, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, 125, 0, 0],
              },
              {
                usrName: 'abcdefghijklmno',
                point: [100, 125, 100, 100, 100],
              },
            ]
          : {
              usrName: 'abcdefghijklmno',
              point: [100, 500, 0, 0, 0],
            };
      }
      const response = await dispatch('fetch', {
        method: 'get',
        url: `/season/leaderboard/detail`,
        params: {
          season,
          rank,
          isMine,
        },
      });

      return response;
    },
    /** 시즌 리더보드 상세 조회 */
    async fetchSeasonLeaderBoardDetail({ dispatch, commit }, { season, rank, isMine }) {
      const boardDetail = await dispatch('getSeasonLeaderBoardDetail', { season, rank, isMine });

      commit('setSeasonLeaderBoardDetail', boardDetail);
      return;
    },
    /** 시즌 리더보드 보상 조회 */
    async getSeasonReward({ dispatch }) {
      if (IS_LOCAL) {
        console.log('getSeasonReward');
        return {
          season: 5,
          rank: 3,
          point: 20,
          reward: 500,
        };
        // return {
        //   data: null,
        // };
      }
      const response = await dispatch('fetch', {
        method: 'get',
        url: `/season/leaderboard/reward`,
      });

      return response;
    },
    /** 시즌 리더보드 보상 조회 */
    async fetchSeasonReward({ dispatch, commit }) {
      const reward = await dispatch('getSeasonReward');

      commit('setSeasonReward', reward);
      return;
    },
    /** 시즌 일자별 상세 조회 */
    async getSeasonDayCaseList({ dispatch }, { season, day }) {
      if (IS_LOCAL) {
        console.log('getSeasonDayCaseList', season, day);
        return status3;
      }
      const response = await dispatch('fetch', {
        method: 'get',
        url: `/season/day`,
        params: {
          season,
          day,
        },
      });

      return response;
    },
    /** 시즌 일자별 상세 조회 */
    async fetchSeasonDayCaseList({ dispatch, commit }, { season, day }) {
      const dayCaseList = await dispatch('getSeasonDayCaseList', { season, day });

      commit('setSeasonDayCaseList', dayCaseList);
      return;
    },
    /** 낙찰/유찰 및  선택하기 */
    async postSeasonDayChoice({ dispatch }, { season, day, choice, bet }) {
      if (IS_LOCAL) {
        console.log('postSeasonDayChoice', season, day, choice, bet);
        return null;
      }
      const response = await dispatch('fetch', {
        method: 'post',
        url: `/season/day`,
        params: {
          season,
          day,
          choice,
          bet,
        },
      });

      return response;
    },
    /** 낙찰/유찰 및  선택하기 */
    async submitSeasonDayChoice({ dispatch }, { season, day, choice, bet }) {
      const point = await dispatch('postSeasonDayChoice', { season, day, choice, bet });

      return point;
    },
    /** 시즌 일자별 랜덤 박스 받기 */
    async postSeasonDayRandomBox({ dispatch }, { season, day }) {
      if (IS_LOCAL) {
        console.log('postSeasonDayRandomBox', season, day);
        return {
          product: 'clover', // clover, lCoupon, rTicket, aCoupon
          unit: 500,
        };
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: `/season/day/reward`,
        params: {
          season,
          day,
        },
      });

      return response;
    },
    /** 시즌 일자별 랜덤 박스 받기 */
    async submitSeasonDayRandomBox({ dispatch }, { season, day }) {
      const reward = await dispatch('postSeasonDayRandomBox', { season, day });

      return reward;
    },
    /** 시즌 일자별 케이스별 상세 조회 */
    async getSeasonDayCaseDetail({ dispatch }, { season, day, caseNo }) {
      if (IS_LOCAL) {
        console.log('getSeasonDayCaseDetail', season, day, caseNo);
        return {
          caseNo: '2024타경54888',
          type: 'Single-family house', // 물건종류
          address: '685-4, Ilwon-dong, Gangnam-gu, Seoul', // 소재지
          courtName: 'Seoul Central District Court', // 법원명
          dateDetails: [
            // 기일내역
            {
              date: '2022-09-01T10:00:00', // 기일
              result: 'Failed Auction', // 결과 없으면 null
              dateType: 'Auction Date', // 기일종류
              lowestSellingPrice: '3612403420', // 최저매각가
            },
            {
              date: '2022-09-01T10:00:00', // 기일
              result: 'Failed Auction', // 결과 없으면 null
              dateType: 'Auction Date', // 기일종류
              lowestSellingPrice: '3612403420', // 최저매각가
            },
            {
              date: '2022-09-01T10:00:00', // 기일
              result: 'Failed Auction', // 결과 없으면 null
              dateType: 'Auction Date', // 기일종류
              lowestSellingPrice: '3612403420', // 최저매각가
            },
          ],
          appraisedValue: '4494421920', // 감정가
          minimumBidPrice: '4494421920', // 최저가
          auctionDepartment: 'Auction Division 11', // 담당부서
          img: 'https://img.openmeta.city/img/ko/store/mobile/banner_241129.webp?ver=2025031901', // 이미지
          claimAmount: '4494421920', // 청구금액
          scheduledDate: '2022-09-01T10:00:00', // 예정매각기일
          caseDate: '2022-09-01T10:00:00', // 사건접수
          auctionStartDate: '2022-09-01T10:00:00', // 경매개시일
          deadLine: '2022-09-01T10:00:00', // 배당요구종기
          etc: '물건비고', // 물건비고
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: `/season/day/building`,
        params: {
          season,
          day,
          caseNo,
        },
      });

      return response;
    },
    /** 시즌 일자별 케이스별 상세 조회 */
    async fetchSeasonDayCaseDetail({ dispatch, commit }, { season, day, caseNo }) {
      const dayCaseDetail = await dispatch('getSeasonDayCaseDetail', { season, day, caseNo });

      commit('setSeasonDayCaseDetail', dayCaseDetail);
      return;
    },
  },
};
